export default "__VITE_ASSET__WTqBSBiX__"